export const checkMarkIcon = `
<svg width="35" height="25" viewBox="0 0 35 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.8712 0L34.4574 2.58621L14.642 22.4007L14.6552 22.4138L12.069 25L12.055 24.9877L12.0436 25L9.45738 22.4138L9.46792 22.4007L0 12.931L2.58621 10.3448L12.055 19.8136L31.8712 0Z" fill="#191919"/>
</svg>
`;
